module.exports = __webpack_public_path__ + "img/38117-084.0376e426.jpg";